import { combineReducers } from "redux";
import loading from "store/state/loading";
import authentication from "store/state/auth";
import forgotPassword from "store/state/forgotPassword";
import changePassword from "store/state/changePassword";
import profileSettings from "store/state/profileSettings";
import avp from "store/state/avp";
import companies from "store/state/companies";
import configItems from "store/state/configItems";
import deal from "store/state/deal";
import enumeratedTypes from "store/state/enumeratedTypes";
import fund from "store/state/fund";
import loan from "store/state/loan/loan";
import loanDetails from "store/state/loan/loanDetails";
import loanContacts from "store/state/loan/loanContacts";
import metrics from "store/state/metrics/metrics";
import prepaymentSchedules from "store/state/loan/prepaymentSchedules";
import companyGuarantors from "store/state/loan/companyGuarantors";
import personalGuarantors from "store/state/loan/personalGuarantors";
import property from "store/state/property";
import cashflows from "store/state/cashflows";
import users from "store/state/users";
import contacts from "store/state/contacts";
import roles from "store/state/roles";
import modal from "store/state/modals/modal";
import quotesModal from "store/state/modals/quotes";
import note from "store/state/note";
import editModal from "store/state/modals/editModal";
import bankSwapEdit from "store/state/modals/bankSwapEdit";
import meta from "store/state/meta";
import featureImage from "store/state/featureImage";
import assignFund from "store/state/modals/assignFund";
import libor from "store/state/libor";
import calculators from "store/state/calculators";
import quotes from "store/state/quote";
import search from "store/state/search";
import testHarness from "store/state/calculators/testHarness";
import portfolio from "store/state/portfolio";
import hedge from "store/state/hedge";
import hedgeEscrow from "store/state/hedgeEscrow";
import notifications from "store/state/notifications";
import creditRatings from "store/state/creditRatings";
import capCalcSettings from "store/state/capCalcSettings";
import heartbeat from "store/state/heartbeat";
import guest from "store/state/guest";
import guestGroup from "store/state/guestGroup";
import properties from "store/state/properties";
import file from "store/state/file";
import splashScreen from "store/state/splashScreen";

// REDESIGNED PAGES
import activeLoanModule from "modules/activeLoan/activeLoan.store";
import paidLoanModule from "modules/paidLoan/paidLoan.store";
import peopleModule from "modules/people/people.store";
import propertyModule from "modules/property/property.store";
import quoteModule from "modules/quote/quote.store";
import reminderModule from "modules/reminder/reminder.store";
import { dashboardReducer as dashboard } from "pages/dashboard/Dashboard.store";
import { quotesReducer as newQuotes } from "pages/quotes/quotes.store";
import { hedgeDetailReducer as newHedgeDetail } from "pages/hedgeDetail/hedgeDetail.store";
import { loanDetailReducer as newLoanDetail } from "pages/loanDetail/loanDetail.store";
import { newDealReducer as newDeal } from "pages/deal/deal.store";
import { dealSettingsReducer as dealSettings } from "pages/dealSettings/dealSettings.store";
import { dealAnalysisReducer as dealAnalysis } from "pages/dealAnalysis/dealAnalysis.store";
import { propertyDetailReducer as newPropertyDetail } from "pages/propertyDetail/propertyDetail.store";
import { quoteDetailReducer as quoteDetail } from "pages/quoteDetail/quoteDetail.store";
import { quoteHistoryReducer as quoteHistory } from "pages/quoteHistory/quoteHistory.store";
import { loanProceedsCalculatorReducer as loanProceedsCalculator } from "modals/LoanProceedsCalculatorModal/loanProceedsCalculator.store";
import { refiCashoutCalculatorReducer as refiCashoutCalculator } from "modals/RefiCashOutCalculatorModal/refiCashoutCalculator.store";
import { prepaymentCalculatorReducer as prepaymentCalculator } from "modals/PrepaymentCalculatorModel/prepaymentCalculatorModel.store";
import { supplementalCalculatorReducer as supplementalCalculator } from "modals/SupplementalCalculatorModal/supplementalCalculatorModal.store";
import { whatIfCalculatorReducer as whatIfCalculator } from "modals/WhatIfCalculatorModal/WhatIfCalculator.store";
import { changeDealStatusModalReducer as changeDealStatusModal } from "modals/ChangeDealStatusModal/changeDealStatusModal.store";
import { uploadSpreadsheetModalReducer as uploadSpreadsheetModal } from "modals/UploadSpreadsheetModal/UploadSpreadsheetModal.store";
import { treasurySnapshotReducer as treasurySnapshot } from "modals/TestHarnessCashflowModal/treasurySnapshot.store";
import { newFundReducer as newFund } from "shared-utility/store/state/fund";
import { newPortfolioReducer as newPortfolio } from "shared-utility/store/state/portfolio";
import { newScreenPreferencesReducer as newScreenPreferences } from "shared-utility/store/state/screenPreferences";
import { lenderReportingSetupReducer as lenderReportingSetup } from "pages/lenderReporting/reportingSetup/reportingSetup.store";
import { lenderReportsNoiSetupReducer as lenderReportsNoiSetup } from "pages/lenderReporting/reportComponentsSetup/noiSetup/noiSetup.store";
import { lenderReportsDscrSetupReducer as lenderReportsDscrSetup } from "pages/lenderReporting/reportComponentsSetup/dscrSetup/dscrSetup.store";
import { lenderReportsDebtYieldSetupReducer as lenderReportsDebtYieldSetup } from "pages/lenderReporting/reportComponentsSetup/debtYieldSetup/debtYieldSetup.store";
import { lenderReportListReducer as lenderReportList } from "pages/lenderReporting/dashboard/dashboard.store";
import { lenderReportingReportComponentReducer as lenderReportingReportComponent } from "pages/lenderReporting/reportingComponents/reportComponent.store";
import { lenderReportingNoiCalculationReducer as lenderReportingNoiCalculation } from "pages/lenderReporting/reportingComponents/noiCalculationDashboard/noiRegularCalculationDashboard/noiRegularCalculationDashboard.store";
import { lenderReportsDscrCalculationReducer as lenderReportsDscrCalculation } from "pages/lenderReporting/reportingComponents/dscrCalculationDashboard/dscrRegularCalculationDashboard/dscrRegularCalculationDashboard.store";
import { lenderReportsDebtYieldCalculationReducer as lenderReportsDebtYieldCalculation } from "pages/lenderReporting/reportingComponents/debtYieldCalculationDashboard/debtYieldRegularCalculationDashboard/debtYieldRegularCalculationDashboard.store";
import { lenderReportingNoiCalculationReducer as lenderReportingNoiProjectedCalculation } from "pages/lenderReporting/reportingComponents/noiCalculationDashboard/noiProjectedCalculationDashboard/noiProjectedCalculationDashboard.store";
import { lenderReportsDscrCalculationReducer as lenderReportsDscrProjectedCalculation } from "pages/lenderReporting/reportingComponents/dscrCalculationDashboard/dscrProjectedCalculationDashboard/dscrProjectedCalculationDashboard.store";
import { lenderReportsDebtYieldCalculationReducer as lenderReportsDebtYieldProjectedCalculation } from "pages/lenderReporting/reportingComponents/debtYieldCalculationDashboard/debtYieldProjectedCalculationDashboard/debtYieldProjectedCalculationDashboard.store";
import { lenderReportingDrawerReducer as lenderReportingDrawer } from "pages/lenderReporting/drawer/lenderReportingDrawer.store";
import { lenderReportFieldManagementReducer as lenderReportFieldManagement } from "pages/lenderReporting/drawer/field-management/fieldManagement.store";
import { lenderReportCalculatedFieldReducer as lenderReportCalculatedField } from "pages/lenderReporting/drawer/field-management/calculated-field/calculatedField.store";
import { lenderReportSourceFileFieldReducer as lenderReportSourceFileField } from "pages/lenderReporting/drawer/field-management/source-file-field/sourceFileField.store";
import { lenderReportSourceFileManagementReducer as lenderReportSourceFileManagement } from "pages/lenderReporting/drawer/source-file-management/sourceFileManagement.store";
import { rentRollFieldReducer as lenderReportRentRollField } from "pages/lenderReporting/drawer/field-management/rent-roll-field/rentRollField.store";
import { lenderReportingSFVersionsReducer as lenderReportingSFVersions } from "pages/lenderReporting/drawer/source-file-management/sourceFileVersions.store";
import { lenderReportNewLineItemManagementReducer as lenderReportNewLineItemManagement } from "pages/lenderReporting/drawer/line-item-management/lineItemManagement.store";
import { lenderReportDscrLineItemManagementReducer as lenderReportDscrLineItemManagement } from "pages/lenderReporting/drawer/dscr-line-items-management/dscrLineItemManagement.store";
import { lenderReportDebtYieldLineItemManagementReducer as lenderReportDebtYieldLineItemManagement } from "pages/lenderReporting/drawer/debt-yield-line-items-management/debtYieldLineItemManagement.store";
import { rentRollsReducer as rentRolls } from "pages/propertyDetail/property-rent-rolls/rentRolls.store";
import { uploadRentRollModalReducer as uploadRentRollModal } from "modals/RentRolls/uploadRentRollModal.store";
import { apiTestHarnessReducer } from "components/Admin/ApiTestHarness/testHarness.store";
import { vendorIntegrationsReducer as vendorIntegrations } from "components/Admin/VendorIntegrations/vendorIntegrations.store";
import { loanProceedsReducer } from "components/Admin/CashOutProceeds/LoanProceedsSettings/LoanProceedsSettings.store";
import { dealScreenerReducer } from "pages/dealScreener/DealScreener.store";
import { sreoScreenerReducer } from "pages/sreoScreener/screener.store";

import { companySponsorReducer as companySponsor } from "../components/Admin/CompanySponsors/companySponsors.store";
import { dealSharingReducer as dealSharing } from "../modals/DealSharing/dealSharing.store";
import { holidayCalendarReducer as holidayCalendar } from "../components/Admin/HolidayCalendar/holidayCalendar.store";
import { cashflowTestHarnessReducer as cashflowTestHarness } from "../components/Admin/Cashflows/cashflowTestHarness.store";
import { debtValuationReducer as debtValuation } from "../pages/debtValuation/debtValuation.store";
import { lenderReportingDashboardReducer as lenderReportingDashboard } from "../pages/lenderReportingDashboard/lenderReportingDashboard.store";
import { appsSettingsReducer as appSettings } from "../components/Admin/AppsSettings/appsSettings.store";
import { appsPageReducer as appsPage } from "../pages/apps/appPage.store";
import { emailCampaignReducer as emailCampaign } from "../pages/campaigns/emailCampaign.store";

import { brokerDashboardReducer as brokerDeals } from "../pages/brokerDashboard/brokerDashboard.store";

import { accountingIntegrationReducer as accountingIntegration } from "./state/accountingIntegration";

const rootReducer = combineReducers({
  loading,
  authentication,
  forgotPassword,
  changePassword,
  profileSettings,
  avp,
  cashflows,
  companies,
  configItems,
  deal,
  enumeratedTypes,
  fund,
  loan,
  loanDetails,
  loanContacts,
  metrics,
  prepaymentSchedules,
  companyGuarantors,
  personalGuarantors,
  property,
  roles,
  modal,
  note,
  editModal,
  meta,
  assignFund,
  featureImage,
  libor,
  calculators,
  bankSwapEdit,
  users,
  contacts,
  quotes,
  quotesModal,
  search,
  testHarness,
  portfolio,
  hedge,
  hedgeEscrow,
  notifications,
  creditRatings,
  capCalcSettings,
  heartbeat,
  guest,
  guestGroup,
  properties,
  file,
  splashScreen,

  // REDESIGNED PAGES
  dashboard,
  newDeal,
  dealSettings,
  dealAnalysis,
  newHedgeDetail,
  newLoanDetail,
  newPropertyDetail,
  quoteDetail,
  quoteHistory,
  newQuotes,
  lenderReportingSetup,
  lenderReportsNoiSetup,
  lenderReportsDscrSetup,
  lenderReportsDebtYieldSetup,
  lenderReportList,
  lenderReportFieldManagement,
  lenderReportCalculatedField,
  lenderReportSourceFileField,
  lenderReportRentRollField,
  lenderReportingReportComponent,
  lenderReportingNoiCalculation,
  lenderReportsDscrCalculation,
  lenderReportsDebtYieldCalculation,
  lenderReportingNoiProjectedCalculation,
  lenderReportsDscrProjectedCalculation,
  lenderReportsDebtYieldProjectedCalculation,
  lenderReportingDrawer,
  lenderReportSourceFileManagement,
  lenderReportingSFVersions,
  lenderReportNewLineItemManagement,
  lenderReportDscrLineItemManagement,
  lenderReportDebtYieldLineItemManagement,
  rentRolls,
  uploadRentRollModal,

  // calculators
  loanProceedsCalculator,
  refiCashoutCalculator,
  prepaymentCalculator,
  supplementalCalculator,
  whatIfCalculator,
  changeDealStatusModal,
  uploadSpreadsheetModal,
  treasurySnapshot,

  activeLoanModule,
  paidLoanModule,
  peopleModule,
  propertyModule,
  quoteModule,
  reminderModule,

  newFund,
  newPortfolio,
  newScreenPreferences,

  apiTestHarnessReducer,
  vendorIntegrations,
  loanProceedsReducer,
  dealScreenerReducer,

  sreoScreenerReducer,

  companySponsor,
  dealSharing,
  holidayCalendar,
  cashflowTestHarness,
  accountingIntegration,
  debtValuation,
  lenderReportingDashboard,

  appSettings,
  appsPage,
  emailCampaign,

  brokerDeals,
});

export default rootReducer;
